/**
 * Iraq Region Data
 * Comprehensive data for the Republic of Iraq
 */

import { Region } from "../../types/regions";

/**
 * Iraq region with current borders
 */
export const IRAQ_REGION: Region = {
  id: "region-iraq",
  code: "iraq",
  name: "Iraq",
  localizedNames: {
    en: "Iraq",
    fa: "عراق",
    ar: "العراق",
    ku: "Êraq",
    tr: "Irak",
  },
  description: "The Republic of Iraq, located in Western Asia",
  // Border data is loaded from src/data/borders/iraq.json via getRegionBorder()

  viewport: {
    center: { lat: 33.2232, lng: 43.6793 },
    zoom: 6,
    minZoom: 5,
    maxZoom: 18,
  },

  area: 438317, // Square kilometers

  status: "hidden",
  visibility: "admin",

  features: {
    canCreateMaps: true,
    canViewPublicMaps: true,
    canUseTemplates: true,
    hasHistoricalData: true,
  },

  defaultMapStyle: "light",
  themeColor: "#ce1126", // Red from Iraqi flag
  flagEmoji: "🇮🇶",
  thumbnailUrl: "/images/regions/iraq-thumbnail.jpg",

  historicalPeriods: [
    {
      id: "mesopotamia",
      name: "Ancient Mesopotamia",
      startYear: -3500,
      endYear: -539,
      description: "The cradle of civilization between the Tigris and Euphrates",
    },
    {
      id: "abbasid",
      name: "Abbasid Caliphate",
      startYear: 750,
      endYear: 1258,
      description: "Baghdad as the center of the Islamic Golden Age",
    },
    {
      id: "ottoman",
      name: "Ottoman Period",
      startYear: 1534,
      endYear: 1920,
      description: "Iraq under Ottoman rule",
    },
    {
      id: "modern",
      name: "Modern Iraq",
      startYear: 1932,
      endYear: undefined,
      description: "Independent Iraq from the Kingdom to the Republic",
    },
  ],

  childRegions: ["region-kurdistan-iraq"],

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  order: 2,
  tags: ["middle-east", "mesopotamia", "arab", "kurdish"],
};

